import MobileDesktopRedirectPage from './MobileDesktopRedirectPage'
import { useMobileNavigation } from '@/hooks/useMobileNavigation'

const MobileLayout = () => {
    const { isMobile, isLeftDrawerOpen, isRightDrawerOpen, closeLeftDrawer, closeRightDrawer } = useMobileNavigation();
    return (
        <div className='flex flex-col h-full' style={{ height: 'calc(100vh - 56px)', backgroundColor: '#000000' }}>
            {/* Mobile Bottom Navigation */}
            {/* {isMobile && <MobileBottomNav />} */}

            {/* Mobile Drawers */}
            {/* <MobileLeftDrawer isOpen={isLeftDrawerOpen} onClose={closeLeftDrawer} /> */}
            {/* <MobileRightDrawer isOpen={isRightDrawerOpen} onClose={closeRightDrawer} /> */}

            {/* Mobile App Banner */}
            <MobileDesktopRedirectPage autoShow={true} delay={3000} /><fieldset></fieldset>
        </div>
    )
}

export default MobileLayout